import { drawCartesianAxes, seriesCategories, valueOf } from './axes.js';

const RADIUS = 4;

function draw(chart, ctx, progress) {
  const categories = seriesCategories(chart.options.series);
  const { yToPixel, xForIndex } = drawCartesianAxes(chart, ctx, categories);
  const hitAreas = [];

  chart.options.series.forEach((s, si) => {
    const color = s.color || chart.options.colors[si % chart.options.colors.length];
    const points = s.data.map((d, i) => ({ px: xForIndex(i), py: yToPixel(valueOf(d)), value: valueOf(d), label: typeof d === 'object' ? d.x ?? d.label : i }));
    const visibleCount = Math.max(1, Math.round(points.length * progress));
    const visiblePoints = points.slice(0, visibleCount);

    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();
    visiblePoints.forEach((p, i) => {
      if (i === 0) ctx.moveTo(p.px, p.py);
      else ctx.lineTo(p.px, p.py);
    });
    ctx.stroke();

    points.forEach((p) => {
      if (progress >= 1) {
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc(p.px, p.py, RADIUS, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 1;
        ctx.stroke();

        hitAreas.push({
          contains: (mx, my) => Math.hypot(mx - p.px, my - p.py) <= 8,
          distance: (mx, my) => Math.hypot(mx - p.px, my - p.py),
          tooltipX: p.px,
          tooltipY: p.py,
          label: `<b>${s.name || 'Series ' + (si + 1)}</b><br>${p.label}: ${p.value}`,
          raw: { seriesIndex: si, seriesName: s.name, dataIndex: points.indexOf(p), x: p.label, y: p.value },
        });
      }
    });
  });

  return hitAreas;
}

const LineChart = { draw };
export default LineChart;
